import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';
// import boardimg from "../assets/blogs/2x/Asset 25@2x.png";
import boardimg from "../../assets/blogs/2x/Asset 25@2x.png";
import { Helmet } from "react-helmet-async";

import elephantImg from "../../assets/blogs/2x/Asset 22@2x.png";
import lionImg from "../../assets/blogs/2x/Asset 31@2x.png";
import cowImg from "../../assets/blogs/2x/Asset 29@2x.png";
import deerImg from "../../assets/blogs/2x/Asset 30@2x.png";
import turtleImg from "../../assets/blogs/2x/Asset 28@2x.png";
import elephiImg from "../../assets/blogs/2x/Asset 32@2x.png";
import geasstopImg from "../../assets/blogs/2x/Asset 33@2x.png";
import geassdivImg from "../../assets/blogs/2x/Asset 23@2x.png";
import blog1Img from "../../assets/blogs/2x/1st-thumbnail copy.png";
import blog2Img from "../../assets/blogs/2x/Blog 2 Set 40.png";
import blog3Img from "../../assets/blogs/2x/Blog 3 Set 9.png";
import blog4Img from "../../assets/blogs/2x/Blog 4 Set 8.png";
import blog5Img from "../../assets/blogs/2x/Blog 5 Set 1.png";
import blog6Img from "../../assets/blogs/2x/Blog 6 Set 3.png";
import blog7Img from "../../assets/blogs/2x/Blog 7 Set 10.png";
import blog8Img from "../../assets/blogs/2x/Blog 8 Set 24.png";
import blog9Img from "../../assets/blogs/2x/Blog 9 Set 22.png";
import blog10Img from "../../assets/blogs/2x/Blog 10 Set 44.png";
import blog11Img from "../../assets/blogs/2x/set  37 blog 11 thumbnail.png";
import blog12Img from "../../assets/blogs/2x/Set 2 Blog 12 thumbnail.png";
import blog13Img from "../../assets/blogs/2x/Blog 13 Set 11 Mind Power.png";
import blog14Img from "../../assets/blogs/2x/Set 42 Blog 14 thumbnail.png";
import blog15Img from "../../assets/blogs/2x/Set 47 Blog 15 Thumbnail.png";
import blog16Img from "../../assets/blogs/2x/Blog 16 Set 31 thumbanil.png";
import blog17Img from "../../assets/blogs/2x/Blog 17 Set 23 Thumbnail.png";
import blog18Img from "../../assets/blogs/2x/Blog 18 Set 28 Thumbnail.png";
import blog19Img from "../../assets/blogs/2x/Blog 19 set 16 Thumbnail.png";
import blog20Img from "../../assets/blogs/2x/Blog 20 Set 5 Thumbnail.png";
import blog21Img from "../../assets/blogs/2x/Set 34 Blog 21 Thumbnail.png";



const ChildhoodBlogPage = () => {
  const navigate = useNavigate();
  const [searchParams, setSearchParams] = useSearchParams();
  
  const pageFromURL = parseInt(searchParams.get('page')) || 1;
  const [currentPage, setCurrentPage] = useState(pageFromURL);
  
  const blogsPerPage = 6;

  const allBlogPosts = [
    {
      id: 1,
      title: "Teach Kids to Be On Time",
      slug: "how-to-teach-kids-to-be-on-time",
      description: "Teaching kids to be on time is one of the most practical life skills yet one of the hardest for young children to understand...",
      date: "20 December 2025",
      readTime: "6 min read",
      animal: "elephant",
      animalImg: elephantImg,
      image: blog1Img
    },
   
    {
      id: 2,
      title: "Teach Kids Not to Waste Food and Wa...",
      slug: "how-to-teach-kids-not-to-waste-food-and-water",
      description: "Simple habits, activities, and a kids moral story that help children learn care, gratitude, and responsibility..",
      date: "28 December 2025",
      readTime: "6 min read",
      animal: "lion",
      // animalImg: cowImg,
      animalImg: lionImg,
      image: blog2Img
    },
     {
      id: 3,
      title: "Teach Kids That Parents Know Best",
      slug: "how-to-teach-kids-that-parents-know-best",
      description: "Simple conversations, activities, and a kids moral story that help children learn trust, safety, and emotional security...",
      date: "03 January 2026",
      readTime: "5 min read",
      animal: "cow",
      animalImg: cowImg,
      image: blog3Img
      
    },
    {
      id: 4,
      title: "Teach Kids Do’s and Don’ts for Safety...",
      slug: "how-to-teach-kids-do-s-and-don-ts-for-safety-and-kindness",
      description: "Simple rules, everyday habits, and a kids moral story to help children make safe and caring choices...",
      date: "10 January 2026",
      readTime: "4 min read",
      animal: "deer",
      animalImg: deerImg,
      image: blog4Img
    },
    {
      id: 5,
      title: "Teach Kids About Stranger Safety",
      slug: "how-to-teach-kids-about-stranger-safety",
      description: "Simple conversations, activities, and a kids moral story to help children stay safe, ask questions, and make careful choices...",
      date: "17 January 2026",
      readTime: "4 min read",
      animal: "turtle",
      animalImg: turtleImg,
      image: blog5Img
    },
    {
      id: 6,
      title: "Teach Kids Not to Take What Is Not...",
      slug: "how-to-teach-kids-not-to-take-what-is-not-theirs",
      description: "Simple conversations, activities, and a kids moral story that help children use their thinking skills...",
      date: "24 January 2026",
      readTime: "5 min read",
      animal: "elephant2",
      animalImg: elephiImg,
      image: blog6Img
    },
    {
      id: 7,
      title: "Teach Kids to Keep Things in Place",
      slug: "how-to-teach-kids-to-keep-things-in-place",
      description: "Simple habits, everyday routines, and a kids moral story that help children build responsibility, awareness, and care...",
      date: "31 January 2026",
      readTime: "5 min read",
      animal: "elephant",
      animalImg: elephantImg,
      image: blog7Img
    },
    {
      id: 8,
      title: "Helping Kids Use Time Well and Prepare",
      slug: "helping-kids-use-time-well-and-prepare-in-advance",
      description: "Simple habits, everyday routines, and a kids moral story that help children learn time awareness, preparation...",
      date: "07 February 2026",
      readTime: "5 min read",
      animal: "lion",
      animalImg: lionImg,
      image: blog8Img
    },
    {
      id: 9,
      title: "Helping Kids Build Self Love and Inner...",
      slug: "helping-kids-build-self-love-and-inner-strength",
      description: "Simple reflections, everyday conversations, and a kids moral story that help children understand their inner world...",
      date: "14 February 2026",
      readTime: "6 min read",
      animal: "cow",
      animalImg: cowImg,
      image: blog9Img
      
    },
    {
      id: 10,
      title: "Helping Kids Learn That Everyone Is...",
      slug: "helping-kids-learn-that-everyone-is-beautiful",
      description: "Simple conversations, everyday moments, and a kids moral story that help children accept differences, show kindness...",
      date: "21 February 2026",
      readTime: "4 min read",
      animal: "deer",
      animalImg: deerImg,
      image: blog10Img
    },
    {
      id: 11,
      title: "Helping Kids Choose What Is Right...",
      slug: "helping-kids-choose-what-is-right-instead-of-what-is-easy",
      description: "Simple conversations, everyday habits, and a kids moral story that help children understand right and wrong...",
      date: "28 February 2026",
      readTime: "6 min read",
      animal: "turtle",
      animalImg: turtleImg,
      image: blog11Img,
    },
    {
      id: 12,
      title: "Helping Kids Learn that Happiness Co...",
      slug: "helping-kids-learn-that-happiness-comes-from-within",
      description: "Simple habits, everyday routines, and a kids moral story that help children learn time awareness, preparation...",
      date: "07 March 2026",
      readTime: "5 min read",
      animal: "elephant2",
      animalImg: elephiImg,
      image: blog12Img
    },
    {
      id: 13,
      title: "Helping kids use their mind to solve...",
      slug: "helping-kids-use-their-mind-to-solve-problems-and-help-others",
      description: "Simple conversations, everyday situations, and a kids moral story that help children understand the power of their...",
      date: "14 March 2026",
      readTime: "5 min read",
       animal: "elephant",
      animalImg: elephantImg,
      image: blog13Img
    },
        {
      id: 14,
      title: "Helping Kids Understand That People...",
      slug: "helping-kids-understand-that-people-matter-more-than-things",
      description: "Simple conversations, everyday situations, and a kids moral story that help children recognise greed, value friendsh...",
      date: "21 March 2026",
      readTime: "4 min read",
      animal: "lion",
      animalImg: lionImg,
      image: blog14Img,
    },
        {
      id: 15,
      title: "Helping Kids Learn Why Spreading Ru...",
      slug: "helping-kids-learn-why-spreading-rumours-hurts-friendships",
      description: "Simple conversations, everyday situations, and a kids moral story that help children understand rumours...",
      date: "28 March 2026",
      readTime: "4 min read",
           animal: "cow",
      animalImg: cowImg,
      image: blog15Img,
    },
    {
      id: 16,
      title: "Helping Kids Believe in Themselves...",
      slug: "helping-kids-believe-in-themselves-and-trust-that-things-workout",
      description: "Simple conversations, everyday moments, and a kids moral story that help children build self belief, trust the journey...",
      date: "5 April 2026",
      readTime: "4 min read",
      animal: "deer",
      animalImg: deerImg,
      image: blog16Img
    },
      {
      id: 17,
      title: "Helping Kids Learn to Control Anger...",
      slug: "helping-kids-learn-to-control-anger-and-manage-big-feelings",
      description: "Simple conversations, everyday moments, and a kids moral story that help children build self belief, trust the journey...",
      date: "10 January 2026",
      readTime: "5 min read",
      animal: "turtle",
      animalImg: turtleImg,
      image: blog17Img
    },
    {
      id: 18,
      title: "Helping Kids Discover Their Inner Pow...",
      slug: "helping-Kids-Discover-Their-Inner-Power-and-Feel-Special",
      description: "Simple conversations, everyday moments, and a kids moral story that help children understand that everyone is special...",
      date: "20 March 2026",
      readTime: "5 min read",
      animal: "elephant2",
      animalImg: elephiImg,
      image: blog18Img
    },
    {
      id: 19,
      title: "Helping Kids Learn Forgiveness and St...",
      slug: "helping-kids-learn-forgiveness-and-strengthen-friendships",
      description: "Simple conversations, everyday situations, and a kids moral story that help children understand forgiveness, rep...",
      date: "27 April 2026",
      readTime: "6 min read",
       animal: "elephant",
      animalImg: elephantImg,
      image: blog19Img
    },
            {
      id: 20,
      title: "Helping Kids Learn to Follow Rules...",
      slug: "helping-kids-learn-to-follow-rules-and-not-be-greedy",
      description: "Simple conversations, everyday situations, and a kids moral story that help children understand greed, respect...",
      date: "4 May 2026",
      readTime: "6 min read",
      animal: "lion",
      animalImg: lionImg,
      image: blog20Img,
    },
      {
      id: 21,
      title: "Helping Kids Build Healthy Habits and...",
      slug: "helping-kids-build-healthy-habits-and-daily-routines",
      description: "Simple conversations, everyday practices, and a kids moral story that help children understand hygiene...",
      date: "11 May 2026",
      readTime: "4 min read",
           animal: "cow",
      animalImg: cowImg,
      image: blog21Img,
    },
  ];

  // ✅ Animal head size control - Desktop & Mobile dono ke liye
  const animalStyles = {
    elephant: { 
      top: '-18%', 
      left: '-20%', 
      transform: 'scale(0.8)',
      width: '200px',      // ✅ Desktop size
      height: '200px',     // ✅ Desktop size
      mobileWidth: '120px',  // ✅ Mobile size
      mobileHeight: '120px'  // ✅ Mobile size
    },
    cow: { 
      top: '-18%', 
      left: '100%', 
      transform: 'translateX(-50%) scale(0.7)',
      width: '190px',      // ✅ Desktop size
      height: '190px',     // ✅ Desktop size
      mobileWidth: '110px',  // ✅ Mobile size
      mobileHeight: '110px'  // ✅ Mobile size
    },
    lion: { 
      top: '-19%', 
      right: '28%', 
      transform: 'scale(0.8)',
      width: '170px',      // ✅ Desktop size
      height: '170px',     // ✅ Desktop size
      mobileWidth: '120px',  // ✅ Mobile size
      mobileHeight: '120px'  // ✅ Mobile size
    },
    deer: { 
      top: '-22%', 
      left: '-21%', 
      transform: 'scale(0.75)',
      width: '180px',      // ✅ Desktop size
      height: '190px',     // ✅ Desktop size
      mobileWidth: '100px',  // ✅ Mobile size
      mobileHeight: '100px'  // ✅ Mobile size
    },
    turtle: { 
      top: '-14%', 
      left: '50%', 
      transform: 'translateX(-50%) scale(0.7)',
      width: '130px',      // ✅ Desktop size
      height: '130px',     // ✅ Desktop size
      mobileWidth: '110px',  // ✅ Mobile size
      mobileHeight: '110px'  // ✅ Mobile size
    },
    elephant2: { 
      top: '-16%', 
      right: '-20%', 
      transform: 'scale(0.8)',
      width: '190px',      // ✅ Desktop size
      height: '190px',     // ✅ Desktop size
      mobileWidth: '120px',  // ✅ Mobile size
      mobileHeight: '120px'  // ✅ Mobile size
    },
    
  };

  const totalPages = Math.ceil(allBlogPosts.length / blogsPerPage);
  const indexOfLastBlog = currentPage * blogsPerPage;
  const indexOfFirstBlog = indexOfLastBlog - blogsPerPage;
  const currentBlogs = allBlogPosts.slice(indexOfFirstBlog, indexOfLastBlog);

  useEffect(() => {
    const pageFromURL = parseInt(searchParams.get('page')) || 1;
    setCurrentPage(pageFromURL);
  }, [searchParams]);

  const goToNextPage = () => {
    if (currentPage < totalPages) {
      const newPage = currentPage + 1;
      setSearchParams({ page: newPage });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const goToPrevPage = () => {
    if (currentPage > 1) {
      const newPage = currentPage - 1;
      setSearchParams({ page: newPage });
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }
  };

  const handleBlogClick = (slug) => {
    navigate(`/blog/${slug}`);
  };

  useEffect(() => {
    if (currentPage > totalPages) {
      setSearchParams({ page: 1 });
    }
  }, [currentPage, totalPages, setSearchParams]);


//for the margintop fix of page 
  const [isMobile, setIsMobile] = useState(window.innerWidth <= 585);

useEffect(() => {
  const handleResize = () => setIsMobile(window.innerWidth <= 585);
  window.addEventListener('resize', handleResize);
  return () => window.removeEventListener('resize', handleResize);
}, []);


  return (
    <>
        <Helmet>
  <title>
    Parenting Tips, Kids Learning & Moral Stories Blog | Jungle Morals
  </title>

  <meta
    name="description"
    content="Explore Jungle Morals blogs on parenting, kids emotional development, moral stories, screen time, learning activities, and positive habits for children."
  />

  <meta
    name="robots"
    content="index, follow"
  />

  <link
    rel="canonical"
    href="https://www.junglemorals.com/blogs"
  />

  {/* Open Graph */}
  <meta
    property="og:title"
    content="Parenting Tips, Kids Learning & Moral Stories Blog | Jungle Morals"
  />

  <meta
    property="og:description"
    content="Explore Jungle Morals blogs on parenting, kids emotional development, moral stories, screen time, learning activities, and positive habits for children."
  />

  <meta
    property="og:url"
    content="https://www.junglemorals.com/blogs"
  />

  <meta
    property="og:type"
    content="website"
  />

  <meta
    property="og:image"
    content="https://www.junglemorals.com/static/media/blog-banner.webp"
  />

  {/* Twitter */}
  <meta
    name="twitter:card"
    content="summary_large_image"
  />

  <meta
    name="twitter:title"
    content="Parenting Tips, Kids Learning & Moral Stories Blog | Jungle Morals"
  />

  <meta
    name="twitter:description"
    content="Explore Jungle Morals blogs on parenting, kids emotional development, moral stories, screen time, learning activities, and positive habits for children."
  />

  <meta
    name="twitter:image"
    content="https://www.junglemorals.com/static/media/blog-banner.webp"
  />

  {/* Schema */}
  <script type="application/ld+json">
    {JSON.stringify({
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "Organization",
          "@id": "https://www.junglemorals.com/#organization",
          name: "Jungle Morals",
          url: "https://www.junglemorals.com/",
          logo: {
            "@type": "ImageObject",
            url: "https://www.junglemorals.com/static/media/logo.webp"
          }
        },
        {
          "@type": "WebSite",
          "@id": "https://www.junglemorals.com/#website",
          url: "https://www.junglemorals.com/",
          name: "Jungle Morals",
          publisher: {
            "@id": "https://www.junglemorals.com/#organization"
          }
        },
        {
          "@type": ["CollectionPage", "Blog"],
          "@id": "https://www.junglemorals.com/blogs#webpage",
          url: "https://www.junglemorals.com/blogs",
          name: "Jungle Morals Blog",
          description:
            "Parenting tips, moral stories, emotional learning, and positive habit guides for children.",
          isPartOf: {
            "@id": "https://www.junglemorals.com/#website"
          }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.junglemorals.com/blogs#breadcrumb",
          itemListElement: [
            {
              "@type": "ListItem",
              position: 1,
              name: "Home",
              item: "https://www.junglemorals.com/"
            },
            {
              "@type": "ListItem",
              position: 2,
              name: "Blogs",
              item: "https://www.junglemorals.com/blogs"
            }
          ]
        }
      ]
    })}
  </script>
</Helmet>
      <div className='' style={{
         minHeight: '100vh',
          position: 'relative',
           overflow: 'hidden',
          marginTop: isMobile ? '-68vh' : '-40vh'

           
           }}>
        <div className="text-center  position-relative">
          <div className="position-relative d-flex align-items-center justify-content-center"
            style={{
              width: "100%",
              minHeight: "220px",
              height: "30vw",
              maxHeight: "350px"
            }}>
            <img src={geasstopImg} alt="grass" className="img-fluid"
              style={{ width: "80%", height: "100%", objectFit: "contain" }}
            />
            <h1 className="position-absolute text-center px-2 font-adventuring "
              style={{
                color: "#2C5F4F",
                fontSize: "clamp(1rem, 5vw, 3.5rem)",
                // fontWeight: "bold",
                // fontFamily: "Georgia, serif",
                margin: 0
              }}
            > 
              Building a better childhood
            </h1>
          </div>  
        </div>

        <div className="container py-5 "  style={{ maxWidth: '1300px' }}>
          <div className="row g-5 justify-content-center">
            {currentBlogs.map((post) => {
              const animalStyle = animalStyles[post.animal];
              return (
                <div key={post.id} className="col-12 col-md-6  col-lg-4 d-flex justify-content-center">
                  <div 
                    className="card h-100" 
                    style={{ 
                      border: 'none',
                      cursor: 'pointer',
                      transition: 'transform 0.2s',
                      maxWidth: '400px',
                      width: '100%'
                    }}
                    onClick={() => handleBlogClick(post.slug)}
                    onMouseEnter={(e) => e.currentTarget.style.transform = 'scale(1.02)'}
                    onMouseLeave={(e) => e.currentTarget.style.transform = 'scale(1)'}
                  >
                    {/* ✅ Animal head with responsive size */}
                    <div 
                      className="animal-head"
                      style={{
                        position: 'absolute',
                        top: animalStyle.top,
                        left: animalStyle.left,
                        right: animalStyle.right,
                        transform: animalStyle.transform,
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                        zIndex: 10,
                      }}
                    >
                      <img 
                        src={post.animalImg} 
                        alt={post.animal}
                      className="animal-img d-none d-md-block"
                        style={{ 
                          width: animalStyle.width,
                          height: animalStyle.height,
                          objectFit: 'contain' 
                        }}
                      />
                    </div>

                    <div style={{
                      height: '240px',
                      backgroundImage: `url(${boardimg})`,
                      backgroundSize: 'contain',
                      backgroundPosition: 'center',
                      backgroundRepeat: 'no-repeat',
                      position: 'relative',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      padding: '10px 10px'
                    }}>
                      <img src={post.image}
                      //  alt={post.title}
                        style={{ width: '100%', height: '100%', objectFit: 'contain', }}
                      />
                    </div>

                    <div style={{
                      width: "50%",
                      minHeight: "150px",
                      height: "30vw",
                      maxHeight: "100px",
                      marginTop: "24%",
                      position: 'absolute',
                      right: '-10%',
                    }}>
                      <img src={geassdivImg} alt="grass decoration"
                        style={{ width: '100%', height: '100%', objectFit: "contain" }}
                      />
                    </div>

                    <div className="card-body" style={{ padding: '1px' }}>
                      <div className="d-flex justify-content-between align-items-center mb-2 font-brandon ">
                        <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>
                          {post.date}
                        </small>
                        <small style={{ color: ' #005d52', fontSize: '12px', fontWeight: "600" }}>
                          {post.readTime}
                        </small>
                      </div>
                      <h5 className="card-title font-brandon" style={{
                        color: '#005d52',
                        fontWeight: 'bold',
                        fontSize: '25px',
                        marginBottom: '10px'
                      }}>
                        {post.title}
                      </h5>
                      <p className="card-text font-brandon " style={{
                        color: '#005d52',
                        fontSize: '16px',
                        lineHeight: '1.5',
                        fontWeight: '400'
                      }}>
                        {post.description}
                      </p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {totalPages > 1 && (
            <div className="d-flex justify-content-center align-items-center gap-3 mt-5">
              <button 
                className="btn btn-success" 
                onClick={goToPrevPage}
                disabled={currentPage === 1}
                style={{
                  width: '70px', 
                  height: '40px', 
                  display: 'flex',
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  borderRadius: '25px',
                  opacity: currentPage === 1 ? 0.5 : 1,
                  cursor: currentPage === 1 ? 'not-allowed' : 'pointer'
                }}
              >
                ←
              </button>
              
              <span style={{ color: '#2C5F4F', fontWeight: 'bold' }}>
                {currentPage}/{totalPages}
              </span>
              
              <button 
                className="btn btn-success" 
                onClick={goToNextPage}
                disabled={currentPage === totalPages}
                style={{
                  width: '70px', 
                  height: '40px', 
                  display: 'flex',
                  alignItems: 'center', 
                  justifyContent: 'center', 
                  borderRadius: '25px',
                  opacity: currentPage === totalPages ? 0.5 : 1,
                  cursor: currentPage === totalPages ? 'not-allowed' : 'pointer'
                }}
              >
                →
              </button>
            </div>
          )}
        </div>
      </div>

      {/* ✅ Mobile responsive CSS */}
      <style jsx>{`
        @media (max-width: 768px) {
          .animal-img {
            width: ${animalStyles.elephant.mobileWidth} !important;
            height: ${animalStyles.elephant.mobileHeight} !important;
          }
        }
      `}</style>
    </>
  );
};

export default ChildhoodBlogPage;
